import { some } from 'lodash';
import { isArrayLike } from './Array';

export function deepStringFind(value: any, query: string): boolean {
    if (isArrayLike(value)) {
        return some(value, (v: any) => deepStringFind(v, query));
    } else if (typeof value == 'object') {
        for (const key in value) {
            if (deepStringFind(value[key], query)) return true;
        }
    } else if (typeof value == 'string') {
        return value.toLowerCase().includes(query.toLowerCase());
    } else if (typeof value == 'number' && !isNaN(Number(query))) {
        return value.toString().includes(query);
    }

    return false;
}
